import PropTypes from 'prop-types';
import React from 'react';

const QuestionComponent = (props) => (
  <div>
    <h2 className="h2-alt">
      Obnovte svoju životnú rovnováhu!
    </h2>
    <div className="offset-bottom">
      <p>
        <i>
          Zistite svoju individuálnu konštitúciu podľa orientačného
          ajurvédského testu a spoznajte lepšie sami seba. Naučte sa ako udržiavať
          svoje duševné a telesné zdravie v&nbsp;prirodzenej rovnováhe a nasledujte to,
          čo vám robí naozaj&nbsp;dobre.
        </i>
      </p>
      <p>
        <strong>Zistenie vášho súčasného pomeru jednotlivých dóš (vata, pitta a
        kapha) preveďte pomocou interaktívneho ajurvédského dóšického testu. </strong>
        Po
        stlačení tlačidla Spustiť test dôjde k&nbsp;spusteniu testu. Stlačte vždy
        jedno z&nbsp;tlačidiel obsahujúce odpoveď na danú otázku, ktorá vás aktuálne
        najviac charakterizuje. Po zodpovedaní všetkých 35&nbsp;otázok dôjde
        k&nbsp;sčítaniu bodov podľa jednotlivých dóš a zobrazí sa ich&nbsp;pomer.
      </p>
      <p>
        Ak máte svoj pomer napr. 60% vata, 30% pitta, 10% kapha, znamená to, že
        ste vata typ a mali by ste podľa toho prispôsobiť svoj jedálniček,
        životný štýl a pracovnú činnosť. U&nbsp;väčšiny ľudí prevažuje vždy
        jedna dóša. V&nbsp;niektorých prípadoch môžu byť rovnomerne zastúpené dve
        dóše a len veľmi zriedka sú v&nbsp;rovnováhe všetky tri&nbsp;dóše.
      </p>
      <p>
        Po skončení testu budete môcť váš výsledný individuálny pomer dóš
        porovnať s&nbsp;jednotlivými odporúčaniami pre každý typ (vata, pitta alebo
        kapha) alebo pre kombinovaný typ, ak vám vyjde rovnocenná prítomnosť
        dvoch&nbsp;dóš.
      </p>
    </div>
    <button
      className="btn btn-default"
      onClick={props.onContinueClick}
    >
      Spustiť test
    </button>
  </div>
);

QuestionComponent.propTypes = {
  onContinueClick: PropTypes.func.isRequired,
  questionCount: PropTypes.number.isRequired,
};

export default QuestionComponent;
